import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import TemplateList from './TemplateList';
import TemplateUploadView from '../TemplateUpload/TemplateUploadView';
import TemplateUpdateView from '../TemplateUpdate';
import Template from './Template';
import TemplateEdit from './TemplateEdit';
import Viewer from '../Viewer';
import PageContentError from '../UI/PageContentError';
import PrivateRoute from '../PrivateRoute';
import { Grid } from '@material-ui/core';
import SignaturePositionsInfoAlert from '../ProcessDetail/SignaturePositionInfoAlert';

const TemplateRoute = () => {
  const match = useRouteMatch();
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={TemplateList} />
      <PrivateRoute exact path={`${path}/new`} component={TemplateUploadView} />
      <PrivateRoute path={`${path}/update/:number`} component={TemplateUpdateView} />
      <PrivateRoute path={`${path}/edit/:number`} component={TemplateEdit} />
      <Route path={`${path}/view/:number`}>
        {(props) =>
          <>
            <Grid container direction='column' alignItems='center' style={{ marginTop: '16px' }}>
              <Grid item xs={10} style={{ width: '100%' }}>
                <SignaturePositionsInfoAlert />
              </Grid>
              <Grid item xs={10} style={{ width: '100%' }}>
                <Viewer {...props} type='template' />
              </Grid>
            </Grid>
          </>
        }
      </Route>
      <Route path={`${path}/:number`} component={Template} />
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

export default TemplateRoute;
